import { useEffect } from 'react';

const useNotificationTimeout = (
    notification,
    onTimeout,
    persistent,
    duration = 2400
) => {
    useEffect(() => {
        if (notification && !persistent) {
            const timeout = setTimeout(() => {
                onTimeout();
            }, duration);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [notification, duration, persistent, onTimeout]);
};

export default useNotificationTimeout;
